import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#2C2C2C] text-white/90">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <p className="text-sm text-white/70 leading-relaxed">
              Creating beautiful, personalized interiors that reflect your unique style and the Florida lifestyle since 2007.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-sm tracking-widest uppercase text-coral">Quick Links</h4>
            <div className="flex flex-col gap-3">
              {['About', 'Services', 'Portfolio', 'Team', 'Contact'].map((item) => (
                <Link
                  key={item}
                  to={`/${item.toLowerCase()}`}
                  data-testid={`footer-link-${item.toLowerCase()}`}
                  className="text-sm text-white/70 hover:text-coral transition-colors"
                >
                  {item}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-sm tracking-widest uppercase text-coral">Contact</h4>
            <div className="flex flex-col gap-3">
              <a
                href="tel:+19413281233"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-coral transition-colors"
              >
                <Phone size={16} />
                (941) 328-1233
              </a>
              <a
                href="mailto:info@cnpurestyle.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-coral transition-colors"
              >
                <Mail size={16} />
                info@cnpurestyle.com
              </a>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>8131 Lakewood Main St #207<br />Lakewood Ranch, FL 34202</span>
              </div>
              <p className="text-sm text-white/70 mt-1">
                Mon–Fri: 8am–4:30pm<br />
                Sat–Sun: Closed
              </p>
            </div>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <h4 className="text-sm tracking-widest uppercase text-coral">Follow Us</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/cnpurestyle/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 flex items-center justify-center border border-white/30 hover:border-coral hover:text-coral transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/cnpurestyle/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 flex items-center justify-center border border-white/30 hover:border-coral hover:text-coral transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
            </div>
            <p className="text-xs text-white/50 mt-6">
              Part of the Neal Communities Family of Companies
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Charlene Neal Pure Style. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            Serving Southwest Florida Since 2007
          </p>
        </div>
      </div>
    </footer>
  );
};
